import React, { useContext } from "react";
import { LuBriefcase } from "react-icons/lu";
import { Language } from "../../App";
import AccountResultsComp from "./AccountResultsComp";

const getIndustrySubtitle = (industry) => {
  const specializations = industry?.specializations
    ?.map((specialization) => specialization?.name)
    .filter(Boolean)
    .join(", ");

  return (
    industry?.industry_profile?.category ||
    industry?.sub_type ||
    specializations ||
    "Organization / Company"
  );
};

export default function IndustryResultsComp({ data, loading }) {
  const { lang } = useContext(Language);

  return (
    <AccountResultsComp
      data={data}
      loading={loading}
      id="industry"
      icon={<LuBriefcase />}
      title={lang?.organization_company || "Organization/Company"}
      fallbackName="Organization / Company"
      getSubtitle={getIndustrySubtitle}
    />
  );
}
